import React from "react";
import { motion } from "framer-motion";
import img from "../../assets/About/about-01.webp";
import img1 from "../../assets/images/Team/ritika.webp";
import img2 from "../../assets/images/Team/prasoon.webp";
import { Link } from "react-router-dom";

const AboutPageSection = () => {
  // Br and Color Palette mapped exactly from the logo  and user requirements
  const COLORS = {
    red: "#9B1B22",       // Deep Crimson Red (from logo)
    cream: "#FAF7F2",     // Premium Cream (from logo background)
    gold: "#D4AF37",      // Luxury Gold (from logo text/accents)
    textDark: "#1A1A1A",  // Deep Charcoal for readability on Cream
    textLight: "#FFFFFF", // Pure White for readability on Red
  };

  return (
    <div className="font-serif overflow-hidden bg-[#FAF7F2]">
      
      {/* --- 1. HERO SECTION (40% RED / 60% CREAM SPLIT) --- */}
      <section
        className="relative min-h-[95vh] flex items-center pt-24 pb-16"
        style={{
          // Hard-stop gradient ensures colors do not mix, exactly 40/60 ratio
          background: `linear-gradient(to right, ${COLORS.red} 0%, ${COLORS.red} 40%, ${COLORS.cream} 40%, ${COLORS.cream} 100%)`,
        }}
      >
        <div className="max-w-7xl mx-auto w-full px-6 md:px-12 grid lg:grid-cols-12 gap-12 items-center relative z-10">
          
          {/* Left: Image aligned over the Red section */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1 }}
            className="lg:col-span-5 relative"
          >
            <div className="aspect-[4/5] overflow-hidden shadow-2xl relative group rounded-xl">
              <div className="absolute inset-0 bg-[#9B1B22]/20 group-hover:bg-transparent transition-colors duration-700 z-10"></div>
              <img
                src={img}
                alt="R & P Law Partners Library"
                className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-1000 scale-105 group-hover:scale-100"
              />
            </div>
            
            {/* Floating Stats Badge */}
            <div
              className="absolute -bottom-8 -right-8 p-8 rounded-xl shadow-xl hidden md:block"
              style={{ backgroundColor: COLORS.cream }}
            >
              <p style={{ color: COLORS.red }} className="text-5xl font-bold mb-1">15+</p>
              <p
                style={{ color: COLORS.gold }}
                className="text-[10px] uppercase tracking-widest font-bold"
              >
                Years of Excellence
              </p>
            </div>
          </motion.div>

          {/* Right: Glassmorphism Card overlapping the split into the Cream section */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="lg:col-span-7 relative z-20"
          >
            <div className="bg-white/60 backdrop-blur-xl p-10 md:p-14 rounded-2xl shadow-[0_8px_32px_rgba(0,0,0,0.05)] border border-white/40">
              {/* <div className="flex items-center gap-4 mb-8">
                <div className="w-12 h-[2px]" style={{ backgroundColor: COLORS.gold }}></div>
                <p
                  className="uppercase tracking-[0.4em] text-[10px] font-bold"
                  style={{ color: COLORS.red }}
                >
                  Established 1995
                </p>
              </div> */}

              <h1
                className="text-5xl md:text-7xl font-bold leading-tight mb-8"
                style={{ color: COLORS.red }}
              >
                Legacy of <br />
                <span className="italic font-light opacity-80" style={{ color: COLORS.gold }}>Justice.</span>
              </h1>

              <div className="space-y-5 text-gray-700 text-sm md:text-base leading-relaxed font-sans text-justify">
                <p>
                  <span className="font-bold" style={{ color: COLORS.red }}>R & P Law Partners</span> law firm focuses on building professional relationships with its clients based on <span className="font-bold">trust, confidentiality and sound business  and technical methodology across all legal services</span>. R & P Law Partners is widely reputed for its consistent quality  and expertise  and has been ranked as a leader in its field.
                </p>
                <p>
                  We focus on the provision of legal services to private wealth clients, covering <span className="font-semibold">human rights matters, writ/SLP, business disputes, commercial, contract, real estate, family and civil law, as well as criminal issues</span>, at all wealth tiers.
                </p>
              </div>

              
<Link to="/contact-us">
  <button
    className="mt-10 px-8 py-4 rounded-lg transition-all duration-300 uppercase tracking-widest text-xs font-bold hover:-translate-y-1 shadow-md hover:shadow-xl"
    style={{ backgroundColor: COLORS.red, color: COLORS.textLight }}
  >
    Contact Us
  </button>
</Link>
            </div>
          </motion.div>
        </div>
      </section>


      {/* ==================== LEADERSHIP TEAM ==================== */}
<section
  className="py-20 lg:py-28"
  style={{ backgroundColor: COLORS.cream }}
>
  <div className="max-w-7xl mx-auto px-6 md:px-12">

    <div className="text-center mb-16">
      <span
        className="uppercase tracking-[0.3em] text-xs font-bold"
        style={{ color: COLORS.gold }}
      >
        Leadership Team
      </span>

      <h2
        className="mt-4 text-4xl md:text-5xl font-bold"
        style={{ color: COLORS.red }}
      >
        Meet Our Team
      </h2>

      <div
        className="w-24 h-[2px] mx-auto mt-6"
        style={{ backgroundColor: COLORS.gold }}
      />
    </div>

    {/* Partner 1 */}
    <div className="grid lg:grid-cols-2 gap-10 items-center mb-20">

      <div className="relative">
        <div
          className="absolute top-4 left-4 w-full h-full rounded-3xl"
          style={{
            border: `2px solid ${COLORS.gold}`,
          }}
        />

        <img
          src={img1}
          alt="Ritika Gautam"
          className="relative w-full h-[350px] md:h-[500px] object-contain rounded-3xl shadow-xl"
        />
      </div>

      <div>
        <span
          className="uppercase tracking-[0.25em] text-xs font-bold"
          style={{ color: COLORS.gold }}
        >
          Managing Partner & Litigation Head
        </span>

        <h3
          className="text-3xl md:text-5xl font-bold mt-3 mb-6"
          style={{ color: COLORS.red }}
        >
          Ritika Gautam
        </h3>

        <p className="text-gray-600 leading-relaxed mb-5 text-justify">
          Ms. Ritika Gautam is the Managing Partner and Litigation Head of R & P Law Partners. She specializes in criminal, matrimonial and various other legal disputes, representing clients before the Supreme Court of India, various High Courts, Tribunals, Commissions and District Courts across Delhi NCR. With extensive experience in litigation and dispute resolution, she has successfully handled a wide range of complex legal matters while providing strategic guidance and effective representation to her clients.
        </p>

        <p className="text-gray-600 leading-relaxed mb-5 text-justify">
          Known for her strong advocacy and client-focused approach, Ms. Gautam is committed to delivering practical and result-oriented legal solutions tailored to the unique needs of each case. Her professional philosophy is built on transparency, trust and long-term relationships, ensuring that every client receives dedicated attention and personalized legal support. Her commitment to excellence and justice has earned her the confidence of individuals, businesses and organizations alike.

        </p>

      

        {/* <div className="grid sm:grid-cols-2 gap-4">

          <div className="bg-white p-5 rounded-xl shadow">
            <p
              className="font-bold mb-2"
              style={{ color: COLORS.red }}
            >
              Email
            </p>
            <p className="text-gray-600 break-all">
              ritika@rplawpartners.com
            </p>
          </div>

          <div className="bg-white p-5 rounded-xl shadow">
            <p
              className="font-bold mb-2"
              style={{ color: COLORS.red }}
            >
              Contact
            </p>
            <p className="text-gray-600">
              +91-7042278441
            </p>
          </div>

        </div> */}
      </div>
    </div>

    {/* Partner 2 */}
    <div className="grid lg:grid-cols-2 gap-10 items-center">

      <div className="order-2 lg:order-1">

        <span
          className="uppercase tracking-[0.25em] text-xs font-bold"
          style={{ color: COLORS.gold }}
        >
          Founder Partner & Litigation Strategist
        </span>

        <h3
          className="text-3xl md:text-5xl font-bold mt-3 mb-6"
          style={{ color: COLORS.red }}
        >
          K. Prasoon Ranjan
        </h3>

        <p className="text-gray-600 leading-relaxed mb-5 text-justify">
          Mr. K. Prasoon Ranjan is the Founder Partner of R & P Law Partners with extensive experience in litigation and dispute resolution. His expertise spans criminal, matrimonial, civil and various other legal disputes. He is recognized for his strategic approach to legal challenges and his ability to provide practical, effective and result-oriented solutions tailored to the specific needs of his clients. Over the years, he has successfully represented individuals and organizations in a wide range of complex legal matters.
        </p>

        <p className="text-gray-600 leading-relaxed mb-5 text-justify">
          Known for his dedication to justice and professional excellence, Mr. Ranjan believes in building strong client relationships based on trust, transparency and personalized legal guidance. His client-centric approach, combined with his strong advocacy and attention to detail, enables him to deliver effective representation across various judicial forums and legal proceedings. His commitment to protecting the interests of his clients continues to be a cornerstone of his legal practice.
        </p>

       

        {/* <div className="grid sm:grid-cols-2 gap-4">

          <div className="bg-white p-5 rounded-xl shadow">
            <p
              className="font-bold mb-2"
              style={{ color: COLORS.red }}
            >
              Email
            </p>
            <p className="text-gray-600 break-all">
              admin@rplawpartners.com
            </p>
          </div>

          <div className="bg-white p-5 rounded-xl shadow">
            <p
              className="font-bold mb-2"
              style={{ color: COLORS.red }}
            >
              Contact
            </p>
            <p className="text-gray-600">
              +91-9661900233
            </p>
            <p className="text-gray-600">
              +91-9953311115
            </p>
          </div>

        </div> */}
      </div>

      <div className="relative order-1 lg:order-2">

        <div
          className="absolute top-4 left-4 w-full h-full rounded-3xl"
          style={{
            border: `2px solid ${COLORS.gold}`,
          }}
        />

        <img
          src={img2}
          alt="K. Prasoon Ranjan"
          className="relative w-full h-[350px] md:h-[500px] object-contain rounded-3xl shadow-xl"
        />
      </div>

    </div>

  </div>
</section>

      {/* --- 2. THE FIRM'S ETHOS (Modern Bento Grid Layout on Cream) --- */}
      <section className="py-24" style={{ backgroundColor: COLORS.cream }}>
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          
          <div className="mb-16 text-center">
            <span style={{ color: COLORS.gold }} className="text-xs font-bold tracking-[0.3em] uppercase block mb-4">
              Core Values
            </span>
            <h2 className="text-4xl md:text-5xl font-bold" style={{ color: COLORS.red }}>
              Foundations of <span className="font-light italic">Client Trust</span>
            </h2>
          </div>

          {/* Bento Box Layout */}
          <div className="grid lg:grid-cols-3 gap-6">
            
            {/* Big Bento Card */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              className="lg:col-span-2 bg-white rounded-3xl p-10 md:p-14 shadow-sm border border-black/5 hover:shadow-lg transition-shadow"
            >
              <h3 className="text-3xl font-bold mb-6" style={{ color: COLORS.red }}>
                Private Wealth & Litigation
              </h3>
              <p className="text-gray-600 font-sans leading-relaxed mb-8">
                We focus on legal services for private wealth clients across all specialist areas. Our approach is rooted in an all-legal services philosophy, ensuring consistent quality that has ranked us as leaders.
              </p>
              
              <div className="grid grid-cols-2 md:grid-cols-3 gap-y-6 gap-x-4">
                {["Criminal Cases", "Civil Cases", "Matrimonial Cases", "Immigration Law", "Company Related Issue", "Commercial Disputes","Cyber Crime","Labor Law","Negotiable Instrument Act Cases","Intellectual Property Rights (IPR)","Copyright & Trademark","Real Estate"].map((item, idx) => (
                  <div key={idx} className="flex items-center gap-3">
                    <div className="w-2 h-2 rotate-45" style={{ backgroundColor: COLORS.gold }}></div>
                    <span className="text-xs uppercase tracking-widest font-bold text-gray-600">{item}</span>
                  </div>
                ))}
              </div>
            </motion.div>

            {/* Vertical Stack Bento Cards */}
            <div className="lg:col-span-1 flex flex-col gap-6">
              
              {/* Red Premium Card */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 }}
                className="flex-1 rounded-3xl p-10 shadow-lg relative overflow-hidden group"
                style={{ backgroundColor: COLORS.red }}
              >
                <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/3 group-hover:scale-150 transition-transform duration-700"></div>
                <h3 className="text-xl font-bold mb-4" style={{ color: COLORS.gold }}>
                  Advisory Services
                </h3>
                <p className="text-white/80 font-sans text-sm leading-relaxed mb-6 relative z-10">
                  Beyond litigation, we provide strategic recurring legal services including company secretarial work  and estate planning.
                </p>
              </motion.div>

              {/* White Minimal Card */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 }}
                className="flex-1 bg-white rounded-3xl p-10 shadow-sm border border-black/5 hover:border-[#D4AF37] transition-colors"
              >
                <p className="text-[10px] tracking-widest text-gray-400 uppercase font-bold mb-4">
                  Implementation
                </p>
                <ul className="space-y-4">
                  {["Asset Acquisition", "Wealth Restructuring", "Probate Services", "Conveyance Work"].map((item, idx) => (
                    <li key={idx} className="text-sm font-sans text-gray-700 border-b border-gray-100 pb-2 flex justify-between items-center group">
                      {item}
                      <span className="opacity-0 group-hover:opacity-100 transition-opacity" style={{ color: COLORS.gold }}>→</span>
                    </li>
                  ))}
                </ul>
              </motion.div>

            </div>
          </div>
        </div>
      </section>

      {/* --- 3. PHILOSOPHY SECTION (Red Base to fulfill the 40% ratio requirement) --- */}
      <section className="py-24 relative overflow-hidden" style={{ backgroundColor: COLORS.red }}>
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/20 to-transparent"></div>
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-16 items-center relative z-10">
          
          <div className="lg:col-span-4">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Our <br />
              <span style={{ color: COLORS.gold }} className="font-light italic">
                Philosophy
              </span>
            </h2>
            <div className="w-20 h-[2px] mb-8" style={{ backgroundColor: COLORS.gold }}></div>
            <p className="text-white/70 font-sans leading-relaxed">
              We operate on principles that have stood the test of time, blending classical legal methodology with aggressive modern strategy.
            </p>
          </div>

          <div className="lg:col-span-8 grid md:grid-cols-2 gap-8">
            {[
              { title: "Integrity", desc: "Honesty is the bedrock of our practice. We maintain absolute transparency in every case." },
              { title: "Precision", desc: "In law, details are everything. Our strategic approach leaves no stone unturned." },
              { title: "Tradition", desc: "We honor the classical roots of legal practice while embracing modern innovation." },
              { title: "Excellence", desc: "We strive for nothing less than the most favorable outcome for our patrons." },
            ].map((item, idx) => (
              <div key={idx} className="group p-8 rounded-2xl border border-white/10 hover:bg-white/5 transition-all duration-300">
                <h4
                  style={{ color: COLORS.gold }}
                  className="text-lg font-bold uppercase tracking-widest mb-3"
                >
                  {item.title}
                </h4>
                <p className="text-white/70 font-sans text-sm leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* --- 4. FOUNDER'S NOTE & STATS (Cream Base) --- */}
      <section className="py-24 px-6 relative" style={{ backgroundColor: COLORS.cream }}>
        
        {/* <div className="max-w-4xl mx-auto text-center relative mb-24">
          <div
            className="text-[15rem] absolute -top-20 left-1/2 -translate-x-1/2 opacity-[0.03] select-none font-serif leading-none"
            style={{ color: COLORS.red }}
          >
            “
          </div>
          <h2
            className="text-3xl md:text-4xl italic font-light leading-relaxed mb-12 relative z-10"
            style={{ color: COLORS.textDark }}
          >
            "The law is a fortress that protects the weak  and keeps the strong
            accountable. At R & P Law Partners, we ensure those walls never crumble."
          </h2>
          <div className="w-12 h-[2px] mx-auto mb-6" style={{ backgroundColor: COLORS.gold }}></div>
          <p className="uppercase tracking-[0.4em] text-xs font-bold" style={{ color: COLORS.red }}>
            Adv. Vikram Rathore
          </p>
          <p className="text-[10px] uppercase tracking-widest mt-2" style={{ color: COLORS.gold }}>
            Founding Partner
          </p>
        </div> */}

        {/* Minimal Stats */}
        <div className="max-w-6xl mx-auto border-t border-black/10 pt-16">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-12">
            {[
              { label: "Successful Cases", value: "1K+" },
              { label: "Expert Attorneys", value: "5+" },
              { label: "Global Clients", value: "1200+" },
              { label: "Awards Won", value: "25+" },
            ].map((stat, i) => (
              <div key={i} className="text-center group">
                <p
                  className="text-4xl lg:text-5xl font-bold mb-3 transition-transform group-hover:-translate-y-2"
                  style={{ color: COLORS.red }}
                >
                  {stat.value}
                </p>
                <p
                  className="text-[10px] uppercase tracking-[0.3em] font-bold"
                  style={{ color: COLORS.gold }}
                >
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </div>

      </section>

    </div>
  );
};

export default AboutPageSection;


